import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSearchProviders } from "../../redux/slice/provider-search/searchProvidersSlice";
import { setLocalStorageItem } from "../../service/utils";
import { t } from "i18next";
function InformationList({ items }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleItemClick = (specialityValue) => {
    const payload = {
      countrySearch: "",
      stateSearch: "",
      citySearch: "",
      zipSearch: "",
      organizationSearch: "",
      pageNumber: 1,
      delta: 10,
      sortDirection: 2,
      sortingField: "",
      addressSearch: null,
      specialitySearch: specialityValue,
      isDownloadPdf: false,
      isSpecialitySearch: true,
    };
    dispatch(getSearchProviders(payload));
    setLocalStorageItem("searchValues", {
      ...payload,
    });
    navigate(`/providerSearch`);
  };
  console.log("items", items);
  
  return (
    <ul className="information-list">
      {items &&
        items.length > 0 &&
        items.map((item, index) => (
          <li key={index}>
            {item.icon && (
              <span className={`bottom-menu-inner`}>
                <i className={`icon-${item.icon}`} aria-hidden="true"></i>
              </span>
            )}
            {item.link ? (
              <a
                href="javascript:void(0)"
                onClick={() => handleItemClick(item.linkValue)}
              >
                {t(item.label)}
              </a>
            ) : (
              t(item.label)
            )}
          </li>
        ))}
        <li>
           <span className={`bottom-menu-inner`}>
              <i className={`icon-download`} aria-hidden="true"></i>
           </span>
           <a href="/documents/d/provider-search/argus-vppn?download=true">{t("argus.value.ppn")}</a>
        </li>
    </ul>
  );
}
InformationList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};
export default InformationList;